(function () {
  'use strict';

  angular.module('sempraWebapp').factory('webSocketActions', webSocketFactory);

  /** @ngInject */
  function webSocketFactory (dispatcher, ActionTypesEnum) {
    return {
      notifyConnectionChange: notifyConnectionChange,
      notifyDeviceChange: notifyDeviceChange,
      notifyDeviceFeedChange: notifyDeviceFeedChange,
      notifyDeviceActuatorChange: notifyDeviceActuatorChange,
      notifyMessagesChange: notifyMessagesChange,
      notifyFinancesChange: notifyFinancesChange,
      notifyNoticeChange: notifyNoticeChange,
      notifyDeviceEventChange: notifyDeviceEventChange
    };

    function notifyConnectionChange (payload) {
      dispatcher.dispatch({
        type: ActionTypesEnum.CONNECTED_CHANGE,
        payload: payload
      });
    }

    function notifyDeviceChange (payload) {
      dispatcher.dispatch({
        type: ActionTypesEnum.DEVICE_STATE_CHANGE,
        payload: payload
      });
    }

    function notifyDeviceFeedChange (payload) {
      dispatcher.dispatch({
        type: ActionTypesEnum.DEVICE_FEED_CHANGE,
        payload: payload
      });
    }

    function notifyDeviceActuatorChange (payload) {
      dispatcher.dispatch({
        type: ActionTypesEnum.DEVICE_ACTUATOR_CHANGE,
        payload: payload
      });
    }

    function notifyMessagesChange (payload) {
      dispatcher.dispatch({
        type: ActionTypesEnum.MESSAGES_UPDATE_AVAILABLE,
        payload: payload
      });
    }

    function notifyFinancesChange (payload) {
      dispatcher.dispatch({
        type: ActionTypesEnum.DAILY_FINANCES_CHANGE,
        payload: payload
      });
    }

    function notifyNoticeChange (payload) {
      dispatcher.dispatch({
        type: ActionTypesEnum.NOTICE_CHANGE,
        payload: payload
      });
    }

    function notifyDeviceEventChange (payload) {
      dispatcher.dispatch({
        type: ActionTypesEnum.DEVICE_EVENT_CHANGE,
        payload: payload
      });
    }

  }
})();
